document.addEventListener('DOMContentLoaded', function () {
  if (!window.mz) {
    return;
  }
  if (mz.context.filterShow) {
  }
  function afterUpdate() {
    setTimeout(() => {
      window?.Globo?.Preorder?.initPreorder();
      window?.initializeCollectionSaveButtons?.();
    }, 500);
    setTimeout(() => {
      window?.Globo?.Preorder?.initPreorder();
      window?.initializeCollectionSaveButtons?.();
    }, 1000);
    if (mz.config.scroll) {
      return;
    }
    mz.config.scroll = { disabled: !0 };
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate);
  }
});
